globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modules = appCustomerSpace.Modules || {};

appCustomerSpace.Modules.InputAccountsMediaAbstractFile = (function () {

  InputAccountsMediaAbstractFile.selector = '.accounts-media-file-field';

  InputAccountsMediaAbstractFile.init = function ($html) {
    $html.find(InputAccountsMediaAbstractFile.selector).each(function () {
      new InputAccountsMediaAbstractFile($(this));
    })
  }

  function InputAccountsMediaAbstractFile($html) {
    this.$html = $html;
    this.init();
  }

  InputAccountsMediaAbstractFile.prototype = {
    init: function () {

      var _this = this;

      _this.$inputFileType = _this.$html.find('.file-type');
      _this.$inputFileId = _this.$html.find('.file-id');
      _this.$preview = _this.$html.find('.thumb img');
      _this.$destroy = _this.$html.find('.file-destroy');

      _this._events();
    },
    _events: function () {
      var _this = this;

      _this.$html.on("change", _this.$inputFileId, function () {
        if ($(this).val() != undefined) {
          _this.$html.find('.btn.delete, .thumb').removeClass('hidden');
          _this.$html.find('.select-file').removeClass('btn-primary').addClass('btn-default').end().find('.select-file-text').text(_this.$html.find('.select-file > span').data('edit'));
        } else {
          _this.$html.find('.select-file').removeClass('btn-default').addClass('btn-primary').end().find('.select-file-text').text(_this.$html.find('.select-file > span').data('set'));
          _this.$html.find('.thumb').addClass('hidden');
        }
      });

      _this.$html.on("click", ".btn.delete", function () {
        _this._delete();
        return false;
      });

      _this.$inputFileId.on('change', function () {
        _this.$destroy.val(_this.$inputFileId.val() == "")
      })
    },
    _delete: function () {
      var _this = this;

      _this.$inputFileType.val('');
      _this.$inputFileId.val('').trigger('change');
      _this.$preview.attr('src', '').attr('alt', '');
      _this.$destroy.val('true');
      _this.$preview.attr('src', _this.$html.data('placeholder-img'));
      _this.$html.find('.btn.delete, .thumb').addClass('hidden');
      _this.$html.find('.select-file').removeClass('btn-default').addClass('btn-primary').end().find('.select-file-text').text(_this.$html.find('.select-file > span').data('set'));
    }
  }

  return InputAccountsMediaAbstractFile;

})();
